import { render, staticRenderFns } from "./ModelingRulesList.vue?vue&type=template&id=65b4ece0&scoped=true&"
import script from "./ModelingRulesList.vue?vue&type=script&lang=js&"
export * from "./ModelingRulesList.vue?vue&type=script&lang=js&"
import style0 from "./ModelingRulesList.vue?vue&type=style&index=0&id=65b4ece0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4ece0",
  null
  
)

export default component.exports